import apiClient from '@/lib/apiClient';
import { buildListParams, extractPaginatedData } from '@/shared/utils/queryUtils';

const ROOMS_BASE = '/admin/chat/rooms';
const MESSAGES_BASE = '/admin/chat/messages';

export const chatApi = {
  // Chat Rooms
  listRooms: async (params: any) => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(ROOMS_BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getRoomById: async (id: any) => {
    const res = await apiClient.get(`${ROOMS_BASE}/${id}`);
    return res.data?.data;
  },

  deleteRoom: async (id: any) => {
    const res = await apiClient.delete(`${ROOMS_BASE}/${id}`);
    return res.data;
  },

  // Messages
  listMessages: async (params: any) => {
    const queryParams = buildListParams(params);
    const res = await apiClient.get(MESSAGES_BASE, { params: queryParams });
    return extractPaginatedData(res);
  },

  getMessageById: async (id: any) => {
    const res = await apiClient.get(`${MESSAGES_BASE}/${id}`);
    return res.data?.data;
  },

  deleteMessage: async (id: any) => {
    const res = await apiClient.delete(`${MESSAGES_BASE}/${id}`);
    return res.data;
  },
};
